const mapper: Record<string, string> = {
  'en-US': 'en',
  fr: 'fr',
  'pt-BR': 'pt',
} as const;

export const languageMapper = (langIsoCode: string): string => mapper[langIsoCode] ?? langIsoCode;
export const languageUnmap = (lang: string): string => {
  const res = Object.entries(mapper).find(([key, value]) => value === lang);
  const langIsoCode = res ? res[0] : lang;
  return langIsoCode;
};
